/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Summary_TitleInputs */

const cs_ebr_summary_title = /** @type {(inputs: Ebr_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import dokončen`)
};

const en_ebr_summary_title = /** @type {(inputs: Ebr_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import finished`)
};

/**
* | output |
* | --- |
* | "Import finished" |
*
* @param {Ebr_Summary_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_summary_title = /** @type {((inputs?: Ebr_Summary_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Summary_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_summary_title(inputs)
	return cs_ebr_summary_title(inputs)
});